import React, { useState, useEffect } from 'react';
import { Box, Stack, Button, TextField, Badge, Tooltip, FormControlLabel, Checkbox, Typography } from '@mui/material'
import { DialogWindow } from  './general';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import dayjs from 'dayjs'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const classes = {
    indProductCont: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    },
    indProductItem :{
        margin: '0px 10px'
    },
    dateCont: {
        display: 'flex',
        marginBottom: 10
    },
    dateInd: {
        marginRight: 20
    },
}


const DateBar = ({fromDate, setFromDate, toDate, setToDate}) => {

  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);

  const now = dayjs();
  const yesterday = now.subtract(1, 'd');

  // Helper to calculate min time
  const getMinTime = (date) => {
    if (!date) return null;

    // If the selected date is today
    /*if (date.isSame(now, 'day')) {
      return now.hour() < 8 ? now.set('hour', 7).set('minute', 0) : now.startOf('hour');
    }*/
    
    // For future dates, set minimum time to 8 AM
    return dayjs().set('hour', 7).set('minute', 0);
  };

  const minTime = getMinTime(fromDate);
  const minEndTime = getMinTime(toDate);
  const maxTime = dayjs().set('hour', 22).set('minute', 0); // 10 PM
    return (
        <div style={classes.dateCont}>
            <div style={classes.dateInd} >
              <LocalizationProvider dateAdapter={AdapterDayjs}>                      
                  <DateTimePicker
                      label="From Date"
                      open={fromDateOpen}
                      skipDisabled={true}
                      onOpen={() => setFromDateOpen(true)}
                      onClose={() => {
                        setFromDateOpen(false)
                        setToDateOpen(true); // Open second picker when first closes
                      }}
                      value={fromDate}
                      minDate={fromDate}
                      maxDate={toDate}
                      minTime={minTime}
                      maxTime={maxTime}
                      ampm={true}
                      timeSteps={{ hours: 1, minutes: 60 }}
                      format='DD/MM/YYYY HH:mm'
                      onChange={(newValue) => {
                          setFromDate(newValue);
                      }}
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          inputProps: { readOnly: true },
                          onClick: (e) => {setFromDateOpen(true); e.stopPropagation()} // optional: avoid triggering focus behavior
                        }
                      }}
                    />
                </LocalizationProvider>
            </div>
            <div style={classes.dateInd}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="To Date"
                      open={toDateOpen}
                      onOpen={() => setToDateOpen(true)}
                      onClose={() => {
                        setToDateOpen(false); // Open second picker when first closes
                      }}
                      value={toDate}
                      skipDisabled={true}
                      ampm={true}
                      maxDate={toDate}
                      minTime={minEndTime}
                      maxTime={maxTime}
                      minDate={fromDate}
                      format='DD/MM/YYYY HH:mm'
                      timeSteps={{ hours: 1, minutes: 60 }}
                      onChange={(newValue) => {
                          setToDate(newValue);
                      }}
                    />
                  </LocalizationProvider>
            </div>
      </div>
    )
}

const IndProduct = ({product, index}) => {
  return (
    
      <div style={classes.indProductCont}>
        <div style={classes.indProductItem}># {index+1}</div>
        <div style={classes.indProductItem}><img height={50} src={product?.image?.thumb??''}/></div>
        <Badge badgeContent={product.count} color="primary">
          <div style={classes.indProductItem}>{product.name}</div>      
        </Badge>
      </div>
    
  )
}

const BillableDates = ({fromDate, toDate, setBillableDates, billableDates, oldBillableDates}) => {
  let dayNameArray = []
  const handleCheckBoxClick = (date) => {
    return (e) => {
      if (e.target.checked) {
        setBillableDates([...billableDates, date])
      } else {
        const _billableDates = [...billableDates]
        const index = _billableDates.indexOf(date)
        if (index > -1) {
          _billableDates.splice(index, 1)
          setBillableDates(_billableDates)
        }
      }
    }
  }
  for (let currentDate = dayjs(fromDate); currentDate.isSameOrBefore(toDate, "day"); currentDate = currentDate.add(1, 'day')) {
    console.log(billableDates)
    dayNameArray.push(
      <Tooltip key={currentDate.format('ddd')}  title={currentDate.format("DD MMM")}>
        <FormControlLabel control={<Checkbox onChange={handleCheckBoxClick(currentDate.format("DD-MM-YYYY"))} checked={billableDates.indexOf(currentDate.format("DD-MM-YYYY")) > -1}/>} label={currentDate.format('ddd')} />
      </Tooltip>)
  }
  return (
    <Stack direction="row" spacing={8} sx={{mb: 2}}>
        <Stack direction="column" alignItems="flex-start">
            <Stack direction="row" alignItems="center">
                <Typography sx={{mr: 1}}>Old Billable Date : </Typography>
                    {oldBillableDates.map(oldBillableDate => (
                        <Tooltip key={dayjs(oldBillableDate, "DD-MM-YYYY").format('ddd')}  title={dayjs(oldBillableDate, "DD-MM-YYYY").format("DD MMM")}>
                            <FormControlLabel control={<Checkbox disabled checked={true}/>} label={dayjs(oldBillableDate, "DD-MM-YYYY").format('ddd')} />
                        </Tooltip>)
                    )}
                </Stack>
            <Typography sx={{ml: 1}} variant="caption" display="block" gutterBottom component="div">{oldBillableDates.length} days </Typography>
        </Stack>
        <Stack direction="column" alignItems="flex-start">
            <Stack direction="row" alignItems="center">
                <Typography sx={{mr: 1}}>Select Billable Date : </Typography>
                    {dayNameArray}
                </Stack>
            <Typography sx={{ml: 1}} variant="caption" display="block" gutterBottom component="div">{billableDates.length} days </Typography>
        </Stack>
    </Stack>
  )
}

const Actions = ({doRevoke, billableDates, handleAmend}) => {
    return (
        <Stack direction="row" spacing={2}>
            <Button sx={{flex: '1 0 auto', mb: 1, alignItems: 'flex-start'}} key={`action2`} variant="contained" onClick={doRevoke} endIcon={<DisabledByDefaultIcon />}>Revoke </Button>
            <Button sx={{flex: '1 0 auto', mb: 1, alignItems: 'flex-start'}} disabled={billableDates.length === 0}  key={`action3`} variant="contained" onClick={handleAmend} endIcon={<CloseFullscreenIcon />}>Amend </Button>
        </Stack>

    )
}

const Body = ({bookingDetails, fromDate, toDate, setFromDate, setToDate, billableDates, setBillableDates, discount, setDiscount, total=0}) => {
    if (bookingDetails) {
        return (
            <Box>
                <Stack direction="row">
                    <Box>
                        <DateBar fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate}/>
                        <BillableDates fromDate={fromDate} toDate={toDate} billableDates={billableDates} setBillableDates={setBillableDates} oldBillableDates={bookingDetails?.billableDates}/>
                        {bookingDetails.products.map((product, index)=><IndProduct index={index} key={`product-${index}`} product={product}/>)}
                    </Box>
                    <Stack spacing={2}>
                        <TextField size="small" value={bookingDetails.advance} disabled label="Advance"/>
                        <TextField size="small" value={discount} onChange={(e)=>setDiscount(parseInt(e.target.value.replace(/[^0-9.]/g, '')))} label="Discount" helperText={`Old Discount : ₹ ${bookingDetails.discount}`}/>
                        <TextField size="small" value={total + discount} disabled onChange={(e)=>setDiscount(e.target.value)} label="Gross Amount" helperText={`Old Gross Amount : ₹ ${bookingDetails.amount + bookingDetails.discount}`}/>
                        <TextField size="small" value={total} helperText={`Old Nett Amount: ₹ ${bookingDetails.amount}`} disabled label="Nett Amount"/>
                        <TextField size="small" value={Math.max(0, total-discount-bookingDetails.advance)} helperText={`Old Balance: ₹ ${bookingDetails.amount - bookingDetails.advance}`} disabled label="Balance"/>
                    </Stack>
                </Stack>
            </Box>
        )
    }
  return null;
}

export default function AmendBooking({open, setOpen, selectedBooking, bookings, doRevoke, doAmend}) {
    const [fromDate, setFromDate] = useState()
    const [toDate, setToDate] = useState()
    const [bookingDetails, setBookingDetails] = useState()
    const [billableDates, setBillableDates] = useState([])
    const [discount, setDiscount] = useState(0)
    const [total, setTotal] = useState()

    useEffect(()=>{
        if (selectedBooking) {
            const book = bookings.find(book=>book._id === selectedBooking)
            setBookingDetails(book)
            setFromDate(dayjs(book.from))
            setToDate(dayjs(book.to))
            setDiscount(book.discount)
        }
    }, [selectedBooking])

    useEffect(()=>{
        if (fromDate && toDate) {
            const currentFromDate = dayjs(fromDate);
            if (currentFromDate.isSame(dayjs(toDate), "day")) {
                console.log("Same day")
                console.log(currentFromDate.format("DD-MM-YYYY"), dayjs(toDate).format("DD-MM-YYYY"));
                setBillableDates([currentFromDate.format("DD-MM-YYYY")])
            }
        }
    }, [fromDate, toDate])

      useEffect(()=>{
        if (bookingDetails) {
          const _total = bookingDetails.products.reduce((acc, item)=>{return acc+(parseInt(item.rent, 10)*billableDates.length*item.count)}, 0)
          setTotal(_total)
        }
      },[bookingDetails, billableDates])

    const handleAmend = () => {
      doAmend(fromDate, toDate, discount, total, billableDates)
    }

    return (
        <DialogWindow
            title={'Amend Booking'}
            Body={<Body
                    bookingDetails={bookingDetails}
                    fromDate={fromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                    setFromDate={setFromDate}
                    billableDates={billableDates}
                    setBillableDates={setBillableDates}
                    discount={discount}
                    setDiscount={setDiscount}
                    total={total}
                />}
            Actions={<Actions doRevoke={doRevoke} billableDates={billableDates} handleAmend={handleAmend}/>}
            open={open}
            setOpen={setOpen} 
            maxWidth={'lg'}
        />
    )
}